// テナント内の全グループを取得する mixin
// ノートテンプレートは閲覧権限に関わらず全グループを対象にできるため、
// auth の accessibleDepartments ではなく /departments/ の全件を使う
export default {
  data() {
    return {
      allDepartments: []
    }
  },
  methods: {
    // 取得できたかどうかを返す。選択肢が空のままフォームを操作させないため、
    // 呼び出し側で失敗時の扱い（画面を出さない等）を決められるようにする
    fetchAllDepartments() {
      // 並び順はグループ管理画面と揃える。ページングで取りこぼさないよう全件を一度に取得する
      return this.$axios.get('/departments/', { params: { limit: 99999, ordering: '-sort_no' } })
        .then(res => {
          this.allDepartments = res.data?.results || []
          return true
        })
        .catch(() => {
          this.$store.commit('notify/set', { isUnknownError: true, type: 'danger' })
          return false
        })
    }
  }
}
